import {useNavigate} from "react-router-dom";

import {ArrowLeftOutlined} from "@ant-design/icons";

import {ReactComponent as Arrow} from "./buttonArrow.svg";

import styles from "./kanban-title.module.scss";

const KanbanTitle = ({title}) => {

    const navigate = useNavigate();

    return (
        <div className={styles.wrapper}>
            <div>
                <ArrowLeftOutlined onClick={()=> navigate(-1)} className={styles.backIcon} />
                <span className={styles.kanban}>Kanban</span>
                <span className={styles.title}>Manage bThere Missions {title}</span>
            </div>
            {/*{status && (<div className={styles.buttonWrapper}>*/}
            {/*    <span className={styles.buttonText}>{status}</span>*/}
            {/*    <span onClick={nextStatus} className={styles.buttonArrow}><Arrow /></span>*/}
            {/*</div>)}*/}
        </div>
    )
}

export default KanbanTitle;
